import { fetchInterceptor } from '../commons/Interceptor'
import { dateFormatToReport } from '../commons/DateUtils'
import { getBaseURL, getToken } from '../environment'

const service = 'orders'
const baseURL = `${getBaseURL()}`

/**
 * Monta os parâmetros comuns à consulta e à exportação.
 *
 * `millId` não é enviado de propósito: o api-gateway o injeta a partir do
 * token (`setMillId`), garantindo que o escopo seja sempre a fábrica do
 * usuário logado.
 */
const mountQueryParams = filters => {
    const { initialDate, finalDate, sellers, clients, urgency } = filters
    const queryParams = new URLSearchParams()

    if (initialDate)
        queryParams.append('dateFrom', dateFormatToReport(initialDate))
    if (finalDate)
        queryParams.append('dateTo', dateFormatToReport(finalDate))

        // Arrays vão como parâmetros repetidos: é o formato que o DTO do backend
        // espera (mesmo padrão de OrderAPI.searchPaginatedOrders).
    ;(sellers || []).forEach(sellerId =>
        queryParams.append('sellerIds', sellerId)
    )
    ;(clients || []).forEach(clientId =>
        queryParams.append('clientIds', clientId)
    )

    if (urgency && urgency !== 'ALL') queryParams.append('urgency', urgency)

    return queryParams
}

const request = async queryParams => {
    return await fetchInterceptor(
        `${baseURL}/${service}/orders/reports/detailed?${queryParams}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        }
    )
        .then(response =>
            response.json().then(({ data, total, totals, message }) => {
                if (!response.ok) throw new Error(message)

                return {
                    data: {
                        orders: data || [],
                        total: total || 0,
                        totals: totals || {
                            ordersCount: 0,
                            totalValue: 0,
                            totalWeightInTonnes: 0,
                            urgentOrdersCount: 0,
                        },
                    },
                }
            })
        )
        .catch(err => {
            console.error('Erro: ', err)
            throw err
        })
}

export const searchDetailedOrderReport = async (page, size, filters) => {
    const queryParams = mountQueryParams(filters)
    queryParams.append('page', page)
    queryParams.append('size', size)

    return await request(queryParams)
}

/**
 * Busca o conjunto filtrado inteiro, ignorando a paginação da tela — a
 * exportação nunca pode devolver só a página visível.
 */
export const fetchDetailedOrderReportForExport = async filters => {
    const queryParams = mountQueryParams(filters)
    queryParams.append('export', 'true')

    return await request(queryParams)
}
